import { Box } from '@mui/material';
import { FC } from 'react';

const logoUrls = [
  'images/img_logo1.png',
  'images/img_logo2.png',
  'images/img_logo3.png',
  'images/img_logo4.png',
  'images/img_logo5.png',
  'images/img_logo6.png',
  'images/img_logo7.png',
  'images/img_logo8.png',
];

const scroll = {
  '@keyframes scroll': {
    from: { transform: 'translateX(0)' },
    to: { transform: 'translateX(-50%)' },
  },
};

const PartnerLogos: FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#fff',
        ...scroll,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: 'fit-content',
          animation: 'scroll 20s linear infinite',
          '&:hover': {
            animationPlayState: 'paused',
          },
        }}
      >
        {[...logoUrls, ...logoUrls].map((src, idx) => (
          <Box
            key={idx}
            sx={{
              flex: '0 0 auto',
              mx: { xs: '30px', sm: '60px' },
              width: {
                xs: '72px',
                sm: '90px',
                md: '120px',
              },
              height: {
                xs: '72px',
                sm: '90px',
                md: '100px',
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={src}
              alt={`logo-${idx}`}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PartnerLogos;
